import React from "react"

import AsyncSelect from '../common/AsyncSelect'

import CreatableSelect from 'react-select/creatable';

import CreateProductCategoryModal from '../modal/CreateProductCategoryModal'

import AuthManager from '../../../utils/AuthManager';
import Backend from '../../../utils/Backend';

export default class Cateogry extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      shop: props.shop,
      categories: [],
      selectedCategories: props.selectedCategories,
    }
  }

  componentDidMount(){
    this._load()
  }

  _load(){
    Backend.getProductCategories()
    .then(categories => {
      this.setState({ categories })
    })
  }

  _getOptions(categories){
    return categories.map(category => ({
      value: category.id,
      label: category.name,
      data: category
    }))
  }

  render(){
    let {
      shop,
      categories,
      selectedCategories,
      showCreateProductCategoryModal
    } = this.state

    let marginClass = categories.length > 0 ? "mt-4" : ""
    return (
      <>
        <div class="kt-checkbox-list mb-3">
          {
             categories.map((category, index) => {
              let checked = selectedCategories.find(selectedCategory => selectedCategory.id == category.id) != null
              return (
        				<label class="kt-checkbox kt-checkbox--brand">
        					<input
                    type="checkbox"
                    checked={checked}
                    onChange={e => {
                      if(checked){
                        let index = selectedCategories.findIndex(selectedCategory => selectedCategory.id == category.id)
                        selectedCategories.splice(index, 1)
                      }
                      else{
                        selectedCategories.push(category)
                      }
                      this.props.onUpdated(selectedCategories)
                    }}
                  />
                  {category.name}
        					<span></span>
        				</label>
              )
            })
          }
        </div>
        <a
          className={`btn btn-bold btn-sm btn-label-brand ${marginClass}`}
          onClick={e => {
            e.preventDefault()
            this.setState({ showCreateProductCategoryModal: true })
          }}
        >
          + Add New Category
        </a>
        <div/>
        <CreateProductCategoryModal
          show={showCreateProductCategoryModal}
          onHide={() => this.setState({ showCreateProductCategoryModal: false })}
          onAdded={category => {
            selectedCategories.push(category)
            categories.push(category)
            this.setState({
              categories,
              selectedCategories,
              showCreateProductCategoryModal: false
            })
          }}
        />
      </>

    )
  }
}
